import { Reducer } from 'redux';
import produce from 'immer';

import { InsightsState, InsightsTypes } from './types';
import { AuthTypes } from '../auth/types';

const INITIAL_STATE: InsightsState = {
  generating: false,
  currentInsight: null,
  history: [],
  historyLoading: false,
  total: 0,
  page: 1,
  totalPages: 0,
  error: null,
  usage: null,
};

const insights: Reducer<InsightsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case InsightsTypes.GENERATE_REQUEST:
      return produce(state, draft => {
        draft.generating = true;
        draft.error = null;
      });
    case InsightsTypes.GENERATE_SUCCESS:
      return produce(state, draft => {
        draft.generating = false;
        draft.currentInsight = action.payload.insight;
        draft.history.unshift(action.payload.insight);
        draft.total += 1;
        draft.error = null;
        if (draft.usage) {
          draft.usage.used += 1;
          draft.usage.remaining = Math.max(0, draft.usage.limit - draft.usage.used);
        }
      });
    case InsightsTypes.GENERATE_FAILURE:
      return produce(state, draft => {
        draft.generating = false;
        draft.error = action.payload.error;
      });
    case InsightsTypes.LIST_REQUEST:
      return produce(state, draft => {
        draft.historyLoading = true;
      });
    case InsightsTypes.LIST_SUCCESS:
      return produce(state, draft => {
        draft.historyLoading = false;
        draft.history = action.payload.insights;
        draft.total = action.payload.total;
        draft.page = action.payload.page;
        draft.totalPages = action.payload.totalPages;
        if (action.payload.usage) draft.usage = action.payload.usage;
      });
    case InsightsTypes.LIST_FAILURE:
      return produce(state, draft => {
        draft.historyLoading = false;
      });
    case InsightsTypes.SELECT_INSIGHT:
      return produce(state, draft => {
        draft.currentInsight = action.payload.insight;
      });
    case AuthTypes.LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default insights;
